import React, { useEffect, useMemo, useRef, useState } from "react";
function AddCalcullateFn(props) {
  const [value1, setValue1] = useState(0);
  const [value2, setValue2] = useState(0);
  const [resualt, setResualt] = useState(0);

  const calculationFn = useMemo(() => {
    let resualt = parseInt(value1) + parseInt(value2);
    console.log("resualt :", resualt);

    return <div>text : {resualt}</div>;
  }, [value1, value2]);

  const inputElement = useRef();

  const changeV1 = (e) => {
    console.log(e);
    setValue1((prev) => {
      console.log("prev ", prev);
      return prev;
    });
    setValue1(e.target.value);
  };
  const changeV2 = (e) => {
    console.log(e);
    setValue2(e.target.value);
  };
  const addFn = () => {
    let resualt = parseInt(value1) + parseInt(value2);
    console.log("resualt :", resualt);
    setResualt(resualt);

    inputElement.current.value = resualt;
  };

  useEffect(() => {
    setResualt("not calculate");
  }, []);

  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
    };
  }, []);

  useEffect(() => {
    console.log("value1 changed ", value1);
    //do something
  }, [value1]);

  return (
    <div>
      <h1>Add Callculate Fn</h1>
      <div>
        value 1 : <input onChange={changeV1} />
      </div>
      <div>
        value 2 : <input onChange={changeV2} />
      </div>
      <button onClick={addFn}>call</button>
      <div>resualt (v1+v2) : {resualt}</div>

      <br />
      <div>
        inputElement : <input ref={inputElement} />
      </div>
      <br />
      {calculationFn}
    </div>
  );
}
export default AddCalcullateFn;
